<template>

	<div class="upload-container">
		<div class="el-upload-list--picture-card " :class="format=='button'?'button-upload':''">
			<div v-if="format=='button'&&list.length>0" style="min-height: 8px;"></div>
			<div v-for="(item,index) in list"
				:class="format=='button'?'m-0  no-borders p-0 w-100 picture-cards':''" class="el-upload-list__item ">
				<el-image v-if="format=='file'&&item.indexOf('.jpg')==-1&&item.indexOf('.png')==-1&&item.indexOf('.jpeg')==-1" style="width: 100%;height: 100%;" :src="$domain+'file/type/'+filePath(item)+'.png'">
				</el-image>
				<el-image v-else-if="!accept" style="width: 100%;height: 100%;" :src="$domain+'file/type/下载.jfif'">
				</el-image>
				<el-image  v-else-if="item.indexOf('.jpg')>-1||item.indexOf('.png')>-1||item.indexOf('.jpeg')>-1" style="width: 100%;height: 100%;" :src="$domain+item">
				</el-image>
				<div style="width: 100%;height: 100%;"  class="relative"v-if="accept=='audio/mp4, video/mp4'&&coverImage">
				<el-image   style="width: 100%;height: 100%;" :src="$domain+coverImage">
				<div class="index-module_btn_play_lg__3qIoI absolute" data-status="play" aria-label="播放"  style="display: block;">
				        <svg class="index-module_icon_play_lg__2Z1Yr" viewBox="0 0 100 100">
				          <circle cx="50" cy="50" r="50" style="fill:#222;fill-opacity:0.75"></circle>
				          <path transform="translate(36, 33)" d="M0.6,2C0.6,2,0,3.5,0,16.9C0,30.3,0.6,32,0.6,32c0,1.5,1.6,2.5,2.9,1.8c0,0,3-0.5,15.2-6.6c12.2-6.1,14.2-8.4,14.2-8.4c1.5-0.7,1.5-2.8,0-3.6c0,0-3.3-3.1-14.2-8.6C7.9,1.1,3.5,0.2,3.5,0.2C2.1-0.5,0.6,0.5,0.6,2z" style="fill:#fff;"></path>
				        </svg>
				      </div>
				</el-image>
				</div>
				<video class="w-100 h-100 hide"    v-if="item.indexOf('.mp4')>-1||item.indexOf('.mp3')" ref="videos" @canplaythrough="canplaythrough" :src="$domain+item" controls=""  name="media"><source :src="dialogImage" type="video/mp4"></video>
			<video class="w-100 h-100 "     v-if="item.indexOf('.mp4')>-1||item.indexOf('.mp3')"    controls=""  name="media"><source :src="dialogImage" type="video/mp4"></video>
			<!-- <div class="w-100 h-100 ">视频</div> -->
				<span class="el-upload-list__item-actions">
					<span v-if="format!='file'&&isShow&&accept" class="el-upload-list__item-preview" @click="imageViewClick(index)">
						<i class="el-icon-zoom-in"></i>
					</span>
 <span
       v-if="format=='file'||!accept"
          class="el-upload-list__item-delete"
          @click="downloadClick(index)"
        >
          <i class="el-icon-download"></i>
		  
        </span>
						<span v-if="!disabled" class="el-upload-list__item-delete"  @click="dellistClick(index)" slot="reference">
													<i class="el-icon-delete"></i>
												</span> 
					<span v-if="list.length>1" class="el-upload-list__item-delete" @click="uplistClick(index)">
						<i class="el-icon-back"></i>
					</span>
					<span v-if="list.length>1" class="el-upload-list__item-delete" @click="downlistClick(index)">
						<i class="el-icon-right"></i>
					</span>
				</span>
			</div>
		</div>
<template v-if="!disabled">
		<el-upload :id="id" v-if="format!='button'&&limit>list.length" :style="{}" class="upload-container  relative" 
			:action="$domain+'/api/Upload/PostUpload'" list-type="picture-card" :accept="accept"
			:show-file-list="false" :headers="authHeaders()" :on-success="successUpload"
			:class="className"
			:on-error="errorUpload" :before-upload="beforeUpload">
<div v-if="distinct" class="weui-mark-vip"><span class="weui-mark-lt bg-orange">封面图</span></div>
		</el-upload> 
		<el-upload :id="id" v-if="format=='button'&&limit>list.length"
			:action="$domain+'/api/Upload/PostUpload'" 
			:class="format=='button'?' upload-div':''" :show-file-list="false" :headers="authHeaders()"
			:on-success="successUpload" :on-error="errorUpload" :before-upload="beforeUpload" :accept="accept">
			<el-button class="" type="text">上传<i class="el-icon-upload el-icon--right"></i></el-button>
		</el-upload>		
</template>
<div v-if="format!='button'&&!placeholder" class="  relative ml-3 input-desc upload-title" style="" >
	推荐分辨率为 750*750，保持视觉元素居中，上传支持{{getType||'所有'}}格式
	</div>
	<div v-if="format!='button'&&placeholder" class="  relative ml-3 input-desc upload-title" style="" >
		推荐分辨率为 {{placeholder}}，保持视觉元素居中，上传支持{{getType||'所有'}}格式
		</div>
		<el-dialog width="50%" title="查看预览" :visible.sync="open">
			<div class="icon-content w-100 dialog-50 ">
				<iframe v-if="dialogImage.indexOf('.jpg')>-1||dialogImage.indexOf('.png')>-1||dialogImage.indexOf('.jpeg')>-1" class="w-100 h-100" style="border: 0px;" :src="dialogImage"></iframe>
				<!-- <el-image  v-if="dialogImage.indexOf('.jpg')>-1||dialogImage.indexOf('.png')>-1" class="w-100 h-100" :src="dialogImage" alt=""></el-image> -->
				<video class="w-100 h-100"  v-else-if="dialogImage.indexOf('.mp4')>-1||dialogImage.indexOf('.mp3')>-1" controls="" autoplay="" name="media"><source :src="dialogImage" type="video/mp4"></video>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="open=false">关闭</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	/**
	 * uploader 通用上传
	 * @description 后台管理上传文件，（不进行压缩处理）。
	 * @tutorial 
	 *  * @property {Boolean} disabled 是否禁用不能上传
	 * @property {Boolean} isShow 是否可以查看预览
	 * @property {String} coverImage 视频封面图
	 * @property {Boolean} distinct 是否去重（键值对用的）
	 * @property {String} className 上传的class样式
	 * @property {Number} index 当数据源是list的时候操作index
	 * @property {String} format 上传的自定义类型
	 * @property {Number} limit 限制上传数量
	 * @property {String} accept 上传类型格式
	 * @property {String} list 数据源
	 * @event {Function} returnCallbackList 当上传成功或者删除触发
	 * @example <com-form-uploader ref="returnImgurlRef":limit='1' :list='form.imgurl'></com-form-uploader>
	 */
	import { Loading} from "element-ui";
	
import * as imageConversion from 'image-conversion' 
import {encrypt} from '@/js/common';
	let loading = null;
	export default {
		props: {
			disabled: {
				type: Boolean,
				default: false
			},
			isShow: {
				type: Boolean,
				default: true
			},
			coverImage: {
			type: String,
			default: ''
			},
			distinct: {
				type: Boolean,
				default: false
			},
			className: {
				type: String,
				default: ''
			},
			index: {
				type: Number,
				default:-1
			},
			format: {
				type: String,
				default: 'image'
			},
			placeholder: {
				type: String,
				default: ''
			},
			limit: {
				type: Number,
				default: 1
			},
			accept: {
				type: String,
				default: 'image/png, image/jpeg, image/jpg, image/jif',
				// default: '*'
			},
		value: {
			type: String,
			default: ''
		},
		},
		watch: {
		    		 value(newval){
							   this.list=newval?newval.split(','):[];
		    		 }
		    	   },
		data() {
			return {
				list:[],
				type:'',
				 id:'uploader'+Math.round(Math.random()*1000),
				dialogImage: '',
				open: false,
				visible: false,
			};
		}
		,computed: {
		  getType() {
		    return this.accept.split(',').map(item=>item.split('/')[1]).join('/');
		  }
		},
		mounted() {
			 this.list=this.value?this.value.split(','):[];
		},
		methods: {
			 canplaythrough() {
						var hour = parseInt((this.$refs.videos[0].duration)/3600);
						var minute = parseInt((this.$refs.videos[0].duration%3600)/60);
						minute=minute<10?'0'+minute.toString():minute;
						var second = Math.ceil(this.$refs.videos[0].duration%60);
						second=second<10?'0'+second.toString():second;
						console.log("这段视频的时长为："+hour+"小时，"+minute+"分，"+second+"秒");
						//document.write("这段视频的时长为："+hour+"小时，"+minute+"分，"+second+"秒");
							this.$emit("callbackList",{index:this.index,list:this.list,length:minute+':'+second})
					},  
			authHeaders(){
				return {
					Authorization: "Bearer " + localStorage.getItem('TOKEN'),
					mpv:'1.25',
					sign:encrypt(new Date().getTime().toString())
				};
			},
			filePath(item){
				return 	item.substring(item.lastIndexOf('.')+1);
			},
			dellistClick(i) {
				this.visible = false;
				this.$confirm("您确认要删除此记录吗", "操作提示", {
					type: 'warning'
				}).then(() => {
				this.list.splice(i, 1);
			this.$emit("input", this.list.join());
			this.returnCallbackList();
				this.$emit("change",'');
				}).catch(() => {});
			},
			downlistClick(i) {
				if (i != this.list.length - 1) {
					this.list[i] = this.list.splice(i + 1, 1, this.list[i])[0];
				} else {
					this.list.unshift(this.list.splice(i, 1)[0]);
				}
					this.$emit("input", this.list.join());
			},
			uplistClick(i) {
				if (i != 0) {
					this.list[i] = this.list.splice(i - 1, 1, this.list[i])[0];
				} else {
					this.list.push(this.list.shift()); 
				}
				this.$emit("input", this.list.join());
			},
			imageViewClick(i) {
				this.dialogImage = this.$domain  +(this.list[i]);
				this.open = true;
			},
			downloadClick(i){
			location.href= 	this.$domain  +(this.list[i]);
			},
			successUpload(res, file) {
				loading.close();
				loading=null;
				if(res.status==500){this.$message.error(res.message);return}
				let result = typeof res == 'string' ? JSON.parse(res) : res;
				this.list.push(result.data.path);
				this.type=file.type;
				this.$emit("input", this.list.join());
				this.$emit("change",result.data.path);
				if(file.type!="video/mp4"){
						this.returnCallbackList();
				}
			},
			errorUpload(e) {
				if (e.status == 401) {
					localStorage.clear();
					this.$router.push('/login');
				} else {
					this.$message.error('Proxy error: Could not proxy request ');
				}
				loading.close();
				loading=null;
			},
			beforeUpload(file) {
				if(file.type&&file.type.indexOf('csv')>-1){
					this.$message.error(file.name+'的格式不正确,请另存为xls或xlsx格式后上传');
					return false;
				}
				
				return new Promise((resolve, reject) => {
				if ((file.size / 1024 / 1024) > 20) {
					this.$message.error('上传的内容不能超过20MB');
					reject(file)
					return false;
				}
				let size=file.size / 1024 / 1024;
				if (file.type.indexOf('image')>-1&&size > 0.5) {
					　imageConversion.compress(file,0.8).then(res=>{
					    　　console.log(res);
						resolve(res)
					  　　})
				}else{
					resolve(file)
				}
				if(!loading){
				loading=  Loading.service({
				      lock: true,   //是否锁定屏幕的滚动
				      text: `正在处理数据中...`,   //loading下面的文字
				      background: "hsla(0,0%,100%,.95);",   //loading的背景色
						     // spinner: ' el-icon-loading', 
							 customClass:'f50',
				      target:"body"    //loading显示在容器
				    });
						 }
				return true;
			})
			},
		returnCallbackList(){
			if(this.index>-1){
				this.$emit("callbackList",{index:this.index,list:this.list})
			}else{
				this.$emit("callbackList",this.list)
			}
		}
		}
	}
</script>
<style >
	.upload-title{
		display: inline-block; width: 166px;height: 120px;line-height: 25px;
	}
	.upload-container {
		  /* background-color: #fff; */
		  /* max-height: 120px; */
		      display: flex;
		      /* align-items: center; */
	}
	
	.upload-container .className {
	  background-color:#f8f8f8!important;
	}
	.upload-container .el-upload--picture-card {
	    border: 0px dashed  #DCDFE6;
		    position: relative;
			 background: #FAFAFA; 
			     width: 120px;
			     height: 120px;
	}
	.upload-container .el-upload--picture-card:before {
	    width: 2px;
	    height: 50px;
	}
	.upload-container .el-upload--picture-card:after {
	    width: 50px;
	    height: 2px;
	}
	.upload-container .el-upload--picture-card:before,
	.upload-container .el-upload--picture-card:after{
	  content:" ";
	  position:absolute;
	  top:50%;
	  left:50%;
	  -webkit-transform:translate(-50%, -50%);
	          transform:translate(-50%, -50%);
	  background-color:#DCDFE6;
	}
	.el-upload-list--picture-card {
		/* max-height: 120px; */
		margin-right: 10px;
		
	}
	.button-upload{
		height: 52px;
	}
	.upload-container .el-upload-list--picture-card:first-child{
		margin-right: 0px;
	}
	.upload-container .el-upload-list--picture-card .el-upload-list__item {
	    border: 1px dashed #c0ccda;
		max-width: 120px;
		max-height: 120px;
		display: inline-block;
	}
	.upload-container:nth-child(2) {
		display: inline-block;
	}

	.picture-cards {
		height: 36px !important;
	}

	.upload-div div {
		width: 100%;
		margin: 8px 0px;
	}
	
	
	.index-module_btn_play_lg__3qIoI {
	    width: 48px;
	    height: 48px;
		top: 48px;
		left:48px;
	    pointer-events: auto;
	}
	.index-module_icon_play_lg__2Z1Yr {
	    width: 100%;
	    height: 100%;
	}
	.weui-mark-vip {
	    left: 0;
	    position: absolute;
	    top: 0;
	    overflow: hidden;
	    height: 50px;
	    width: 90px;
	}
	.weui-mark-lt {
	    color: #fff;
	    display: block;
	    font-size: 0.875em!important;
	    left: -0.6875em;
	    height: 1.3em;
	    line-height: 1em!important;
	    position: relative;
	    text-align: center;
	    top: 0.875em;
	    transform: rotate(
	-45deg
	);
	    width: 4.375em;
	    padding: 0.125em;
	}
	.bg-orange {
	    background-color: #409EFF;
	}
</style>
